export const deleteProductsPhysicalConfigurationOption = `mutation ($date: timestamp, $id: Int!) {
    item: update_prodigio_product_physical_configuration_options(where: {id: {_eq: $id}}, _set: {deleted: $date}) {
      affected_rows
    }
  }`;
